module.exports = __webpack_public_path__ + "img/7_115.c2b6eac9.png";